import React from "react";
import Image from "next/image";

const TalentSetMobile = () => {
  //   // State to track hover on each card

  return (
    <>
      {/* mobile version */}
      <div className="w-full py-10  relative bg-center bg-[#071B30] md:hidden block">
        <div className="mx-auto text-white z-50 relative">
          {/* Heading */}
          <h2 className="font-bold text-[20px] leading-[115%] tracking-[-0.8px] text-white text-center mb-8">
            Work Backwards from <br />
            Industry Shortages & Skill Gaps <br />
            <span className="border-[#ca7216] border-b-2 leading-[115%] tracking-[-0.8px]">
              to Set Talent Up for Success
            </span>
          </h2>

          {/* Card Section */}
          <div className="flex flex-wrap justify-center gap-4">
            {/* Accounting Card */}
            <div className="bg-white rounded-[12px] p-2 w-[156px] h-[175px] flex flex-col items-center justify-center">
              <Image
                priority
                src="/about-us/set1.png"
                alt="Accounting Image"
                className="h-[119px] w-[137px] mb-2"
                width={137}
                height={119}
              />
              <h2 className="text-black text-center font-bold text-[16px] leading-[126%]">
                Accounting
              </h2>
            </div>

            {/* Healthcare Card */}
            <div className="bg-white rounded-[12px] p-2 w-[156px] h-[175px] flex flex-col items-center justify-center">
              <Image
                priority
                src="/about-us/set2.png"
                alt="Healthcare Image"
                className="h-[119px] w-[137px] mb-2"
                width={180}
                height={180}
              />
              <h2 className="text-black text-center font-bold text-[16px] leading-[126%]">
                Healthcare
              </h2>
            </div>

            {/* Business Card */}
            <div className="bg-white rounded-[12px] p-4 w-[156px] h-[175px] flex flex-col items-center justify-center">
              <Image
                priority
                src="/about-us/set3.png"
                alt="Business Image"
                className="h-[119px] w-[137px] mb-2"
                width={180}
                height={180}
              />
              <h2 className="text-black text-center font-bold text-[16px] leading-[126%]">
                Business
              </h2>
            </div>

            {/* Technology Card */}
            <div className="bg-white rounded-[12px] p-4 w-[156px] h-[175px] flex flex-col items-center justify-center">
              <Image
                priority
                src="/about-us/set4.png"
                alt="Technology Image"
                className="h-[119px] w-[137px] mb-2"
                width={180}
                height={180}
              />
              <h2 className="text-black text-center font-bold text-[16px] leading-[126%]">
                Technology
              </h2>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TalentSetMobile;
